import React, { useEffect } from "react";
import MyComponent from "../customhook/axios";
import { companyName } from "./Constants";

const Section = () => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      window.scrollTo(0, 0);
    });
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    document.title = companyName;
  }, []);

  return (
    <>
      {/* Banner Area */}
      <section id="home_one_banner" className="top-page">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="banner_one_text">
                <h1>
                  Where Would You <span className="span-c">Like To Go?</span>
                </h1>
                <h3>
                  "Unlock new horizons! Book your flight and embark on an extraordinary escape."
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Form Area */}
      <section id="theme_search_form">
        <div className="container">
          <div className="theme_search_form_area">
            <MyComponent />
          </div>
        </div>
      </section>

      {/* Imagination Area */}
      <section id="go_beyond_area" className="section_padding_top">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-3 col-md-6 col-sm-6 col-12">
              <div className="heading_left_area">
                <h2>
                  Take Off with <span> Ease</span>
                </h2>
                <h5>Your Ultimate Flight Booking Destination!</h5>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-12">
              <div className="imagination_boxed">
                <a href="#home_one_banner">
                  <img src="images/imagination1.png" alt="img" />
                </a>
                <h3>
                  <a href="#home_one_banner">
                    25% Discount for all <span>Airlines</span>
                  </a>
                </h3>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-12">
              <div className="imagination_boxed">
                <a href="#home_one_banner">
                  <img src="images/imagination2.png" alt="img" />
                </a>
                <h3>
                  <a href="#home_one_banner">
                    Travel around<span>the world</span>
                  </a>
                </h3>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-12">
              <div className="imagination_boxed">
                <a href="#home_one_banner">
                  <img src="images/imagination3.png" alt="img" />
                </a>
                <h3>
                  <a href="#home_one_banner">
                    Luxury resorts<span>top deals</span>
                  </a>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Section;
